import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// Scroll restoration (ux-polish.md item 146):
// - Restore prior scroll position on Back/Forward (POP) navigation everywhere.
// - PUSH/REPLACE navigations start at top.
// - Exception: the Watch feed always starts at top regardless of direction.
//   (Watch lands in Phase 5; add its path prefix here when it exists.)
const TOP_ALWAYS_PREFIXES = ["/watch"];

const STORE_KEY = "samtwo_scroll_positions";
const readPositions = () => {
  try { return JSON.parse(sessionStorage.getItem(STORE_KEY) || "{}"); } catch { return {}; }
};
const writePositions = (map) => {
  try { sessionStorage.setItem(STORE_KEY, JSON.stringify(map)); } catch {}
};

const isTopAlways = (pathname) =>
  TOP_ALWAYS_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"));

// Retry across frames until content is tall enough to reach the target
// (page-transition exit can delay the incoming route's mount).
const scrollToPosition = (top) => {
  let tries = 0;
  const attempt = () => {
    window.scrollTo({ top, left: 0 });
    tries += 1;
    if (window.scrollY < top - 2 && tries < 30) requestAnimationFrame(attempt);
  };
  requestAnimationFrame(attempt);
};

export const ScrollRestoration = () => {
  const location = useLocation();
  const navType = useNavigationType();
  const key = location.key || "default";

  // Continuously record the scroll position for the current history entry.
  useEffect(() => {
    const onScroll = () => {
      const map = readPositions();
      map[key] = window.scrollY;
      writePositions(map);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [key]);

  useEffect(() => {
    if (isTopAlways(location.pathname)) {
      scrollToPosition(0);
      return;
    }
    if (navType === "POP") {
      const saved = readPositions()[key];
      scrollToPosition(typeof saved === "number" ? saved : 0);
    } else {
      scrollToPosition(0);
    }
  }, [key, navType, location.pathname]);

  return null;
};
